import { AllSubstringsIndexStrategy, Search } from 'js-search';
import queryString from 'query-string';

window.MapService = {
    siteIds: [],
    events: _.extend({}, Backbone.Events),
    filter: '',
    lat: null,
    lng: null,
    searchIndexer: null,
    zoom: null,

    init: function() {
        const { lat, lng, zoom } = queryString.parseUrl(window.location.href).query;
        if (zoom && `${parseInt(zoom)}` === zoom) {
            this.zoom = parseInt(zoom);
        }
        if (lat && `${parseFloat(lat)}` === lat) {
            this.lat = parseFloat(lat);
        }
        if (lng && `${parseFloat(lng)}` === lng) {
            this.lng = parseFloat(lng);
        }
        this.siteIds = WiseMetering.zones.activeSites().pluck('id');
        this.rebuildSearch();
        this.events.on('map:search:start', this.setFilter.bind(this));
        WiseMetering.zones.on('add change remove', this.rebuildSearch.bind(this));
    },

    rebuildSearch: function() {
        this.searchIndexer = new Search('id');
        this.searchIndexer.indexStrategy = new AllSubstringsIndexStrategy();

        ['address', 'name', 'tags'].forEach(key => this.searchIndexer.addIndex(key));

        const sites = WiseMetering.zones.activeSites().map(site => ({
            address: WiseMetering.utils.searchableText(site.get('address').full_address),
            id: site.id,
            name: WiseMetering.utils.searchableText(site.get('name')),
            tags: site.tagNames().map(tag => WiseMetering.utils.searchableText(tag))
        }));

        this.searchIndexer.addDocuments(sites);
    },

    set: function(params) {
        const newParams = Object.assign({ lat: this.lat, lng: this.lng, zoom: this.zoom }, params);

        this.lat = newParams.lat;
        this.lng = newParams.lng;
        this.zoom = newParams.zoom;

        const newUrl = WiseMetering.utils.replaceQueryString(newParams);
        Backbone.history.navigate(newUrl, { replace: true, trigger: false });
    },

    setFilter: function(filter) {
        if (filter === '') {
            this.siteIds = WiseMetering.zones.activeSites().pluck('id');
        } else {
            const results = this.searchIndexer.search(WiseMetering.utils.searchableText(filter));
            this.siteIds = results.map(result => result.id);
        }
        this.filter = filter;
        this.events.trigger('map:search:end', this.siteIds);
    }
};
